export default class Switch {
  constructor(element) {
    this.element = element;
    this.defaultTarget = document.getElementById(this.element.querySelectorAll('[data-switch-target]')[0].dataset.switchTarget);
    this.activeTarget = document.getElementById(this.element.querySelectorAll('[data-switch-target]')[1].dataset.switchTarget);
    this.checked = false;
    this.mounted = false;

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e) {
    this.toggle();
  }

  activate() {
    this.element.setAttribute('aria-checked', 'true');
    this.defaultTarget.setAttribute('aria-hidden','true');
    this.activeTarget.setAttribute('aria-hidden', 'false');
    this.checked = true;
    this.element.dispatchEvent(new CustomEvent("switch:toggle", { detail: { switch: this } }));
  }

  deactivate() {
    this.element.setAttribute('aria-checked', 'false');
    this.defaultTarget.setAttribute('aria-hidden','false');
    this.activeTarget.setAttribute('aria-hidden', 'true');
    this.checked = false;
    this.element.dispatchEvent(new CustomEvent("switch:toggle", { detail: { switch: this } }));
  }

  toggle() {
    if (this.checked) {
      this.deactivate();
    } else {
      this.activate();
    }
  }

  mount() {
    this.element.setAttribute('role', 'switch');
    this.element.setAttribute('aria-checked', 'false');
    this.defaultTarget.setAttribute('aria-hidden', 'false');
    this.activeTarget.setAttribute('aria-hidden', 'true');
    this.checked = false;
    this.mounted = true;

    this.element.addEventListener('click', this.handleClick);
    this.element.dispatchEvent(new CustomEvent("switch:mounted", { detail: { switch: this } }));
  }

  unmount() {
    this.element.removeAttribute('role');
    this.element.removeAttribute('aria-checked');
    this.defaultTarget.removeAttribute('aria-hidden');
    this.activeTarget.removeAttribute('aria-hidden');
    this.checked = false;
    this.mounted = false;

    this.element.removeEventListener('click', this.handleClick);
    this.element.dispatchEvent(new CustomEvent("switch:unmounted", { detail: { switch: this } }));
  }
}
